<script>

  import { fade } from "svelte/transition";
  import { onMount } from "svelte";


  export let data;
  export let open;
  export let universalMode;
  const toggle = () => (open = !open);

  export let bg;
  export let fg;

  $: bg = !universalMode ? bg : "#eee";
  export let shadow;
  let length = 24;
  export let i = 1;

  onMount(async () => {
  
  });
  
</script>

<div class="index-container" class:open style="--fg:{fg};--bg:{bg}">
  <div class="top-bar">
    <div />
    <div>
      {#if !open}
        <button class="index-trigger" on:click={toggle}>Lassen</button>
      {/if}
    </div>
    <div>
     <button class="index-trigger close">
     
      </button>
      {#if open}
        <button class="index-trigger close" on:click={toggle}>&times</button>
      {/if}
    </div>
  </div>

  {#if open}
    <div class="credits" transition:fade>
      <section class="explainer">
        <div>
          <h1>
            <span class="title"> Lassen<br />(This is an Emergency)</span><br
            /><span class="margo">małgorzata stankiewicz</span>
          </h1>
          <p>
            Reflecting on strategies of how to process the inundation of
            information and images circulating today about the climate crisis,
            Zurich-based Polish artist Małgorzata Stankiewicz raises questions
            about the impact and role of mass media.
          </p>
          <p>
            Presenting a selection of six abstract images with overlaid text
            from her series Lassen (This Is an Emergency) as large-scale posters
            throughout Toronto’s streets, she offers a meditation on the
            depiction of landscape in the Anthropocene—an era of accelerated
            environmental change.
          </p>
          <p>
            Mimicking a guerilla advertising campaign, Stankiewicz’s project
            maps its way through Toronto, expanding upon the work’s function as
            art-based activism and protest. The six unique posters seen at
            street level are accompanied by this online collection of images,
            audio guides and research by the artist.
          </p>
        </div>
        <div class="logobox">
          <a href="https://scotiabankcontactphoto.com"
            ><svg
              id="c21_logo"
              viewBox="0 0 109.49 57.03"
              preserveAspectRatio="xMinYMin meet"
              fill="currentColor"
              style="enable-background:new 0 0 109.49 57.03;"
              xml:space="preserve"
              ><path
                d="M4.45 5.73C3.02 5.43.93 4.96.93 2.92c0-.98.53-1.59.91-1.92C2.72.24 3.8.16 4.48.16c.7 0 1.76.07 2.66.73.97.71 1.17 1.72 1.26 2.32l-1.32.09c-.01-.31-.06-1.09-.8-1.63-.5-.37-1.13-.48-1.76-.48-1.19 0-2.23.49-2.23 1.55 0 1.09 1.09 1.34 1.94 1.54l1.09.28c.76.18 1.16.27 1.55.43 1.48.62 1.7 1.8 1.7 2.46 0 .92-.38 1.79-1.26 2.39-.95.64-2.08.7-2.68.7-.89 0-3.95-.14-4.18-3.4l1.41-.18c.01.38.06 1.25.8 1.9.56.49 1.3.66 2.03.66 1.4 0 2.46-.69 2.46-1.97 0-1.15-.91-1.45-1.87-1.65l-.83-.17zM20.13 6.71c-.42 1.87-2 3.83-4.87 3.83-3.26 0-4.83-2.45-4.83-5.18 0-2.79 1.61-5.18 5-5.18 3.41 0 4.25 2.36 4.49 3.02l-1.33.28c-.13-.36-.22-.69-.59-1.1-.47-.59-1.34-1.15-2.59-1.15-1.05 0-2.07.42-2.71 1.25-.63.78-.83 1.82-.83 2.82 0 2.45 1.25 4.17 3.52 4.17 1.47 0 2.96-.83 3.27-2.91l1.47.15zM26.44.17c-2.45 0-4.98 1.52-4.98 5.18 0 3.07 1.93 5.18 4.94 5.18 3.27 0 5-2.32 5-5.28 0-3.21-2.19-5.08-4.96-5.08zm.01 9.33c-2.54 0-3.56-2.07-3.56-4.14 0-2.22 1.06-4.14 3.55-4.14 2.28 0 3.52 1.65 3.53 4.04.02 2.03-.86 4.24-3.52 4.24zM36.17 1.56v8.72h-1.33V1.56h-2.96V.4h7.24v1.16h-2.95zM41.79.42v9.87h-1.33V.42h1.33zM48.41.42h-1.37l-3.76 9.87h1.4l1.1-3.02h3.76l1.07 3.02H52L48.41.42zM46.2 6.16l1.51-4.11 1.44 4.11H46.2zM59.6 5.09c.74-.22 1.51-.94 1.51-2.14 0-1.54-1.19-2.26-2.18-2.46-.4-.07-.76-.07-1.33-.07h-4.07v9.87h3.86c1.45-.02 2.14-.02 2.91-.52 1.05-.69 1.12-1.74 1.12-2.21-.01-1.93-1.45-2.36-1.82-2.47zm-4.83-3.51h3.06c.53 0 1.89.02 1.89 1.44 0 .29-.07.62-.25.88-.45.67-1.15.67-2.64.67h-2.06V1.58zm4.14 7.46c-.28.07-.52.07-1.22.09h-2.92V5.69h2.42c1.22.02 1.52.03 1.92.2.11.06.95.43.95 1.58-.01.76-.32 1.37-1.15 1.57zM67.19.42h-1.37l-3.76 9.87h1.4l1.1-3.02h3.76l1.07 3.02h1.39L67.19.42zm-2.21 5.74 1.51-4.11 1.44 4.11h-2.95zM79.98.42v9.87h-1.19l-5.41-8.02.11 8.02h-1.23V.42h1.23l5.35 7.91-.06-7.91h1.2zM84.71 5.43l-1.4 1.41v3.44H82V.42h1.32v4.82L88 .42h1.62l-4 4.08 4.17 5.79H88.2l-3.49-4.86zM10.22 23.13c-.25.47-.49.92-.96 1.4-1.01.99-2.42 1.45-3.83 1.45-3.52 0-5.12-2.66-5.12-5.18 0-2.66 1.78-5.35 5.12-5.35 1.5 0 2.92.53 3.95 1.59.42.43.62.77.83 1.16L7.6 19.5c-.25-.59-.73-1.63-2.04-1.63-.69 0-1.12.32-1.33.53-.74.71-.74 1.83-.74 2.22 0 1.47.54 2.85 2.08 2.85 1.45 0 1.89-1.29 2-1.62l2.65 1.28zM16.7 15.44c-3.56 0-5.31 2.49-5.31 5.31 0 2.25 1.21 5.24 5.25 5.24 3.87 0 5.34-2.85 5.34-5.35 0-2.34-1.38-5.2-5.28-5.2zm0 8.06c-1.48 0-2.18-1.03-2.18-2.75 0-2.04 1.06-2.81 2.19-2.81.28 0 1.48.04 1.96 1.41.14.39.18.83.18 1.3-.01 1.85-.89 2.85-2.15 2.85zM23.59 15.81h3.31l2.22 3.73c.54 1.02.7 1.32 1.2 2.42-.09-.96-.1-1.17-.13-2.28v-3.87h2.92v9.87h-3.35l-2-3.41c-.57-.98-.74-1.29-1.37-2.6.07.89.09 1.12.1 2.01v4h-2.91v-9.87zM34.9 15.79h8.12v2.45h-2.5v7.44H37.4v-7.44h-2.5v-2.45zM50.31 15.81h-3.55l-3.78 9.87h3.35l.43-1.37h3.44l.43 1.37h3.35l-3.67-9.87zm-2.87 6.29 1.08-3.48 1.05 3.48h-2.13zM64.55 23.13c-.25.47-.49.92-.96 1.4-1.01.99-2.42 1.45-3.83 1.45-3.52 0-5.12-2.66-5.12-5.18 0-2.66 1.78-5.35 5.12-5.35 1.5 0 2.92.53 3.95 1.59.42.43.62.77.83 1.16l-2.61 1.3c-.25-.59-.73-1.63-2.04-1.63-.69 0-1.12.32-1.33.53-.74.71-.74 1.83-.74 2.22 0 1.47.54 2.85 2.08 2.85 1.45 0 1.89-1.29 2-1.62l2.65 1.28zM65.88 15.79H74v2.45h-2.5v7.44h-3.12v-7.44h-2.5v-2.45zM6.83 31.36c-.52-.16-1.08-.16-1.57-.16H1v9.87h1.27v-4.18h2.85c.6 0 1.09 0 1.58-.16 1.32-.41 1.82-1.67 1.82-2.74 0-1.14-.53-2.22-1.69-2.63zm-.09 3.92c-.45.45-.96.45-1.72.45H2.27v-3.4h3.05c.46 0 .95.01 1.39.38.46.39.52.92.52 1.26-.02.49-.15.98-.49 1.31zM16.96 36.55H11.6v4.51h-1.32v-9.88h1.32v4.21h5.37v-4.21h1.33v9.88h-1.33l-.01-4.51zM25.55 30.95c-2.45 0-4.98 1.52-4.98 5.18 0 3.07 1.93 5.18 4.94 5.18 3.27 0 5-2.32 5-5.28.01-3.21-2.19-5.08-4.96-5.08zm.03 9.34c-2.55 0-3.57-2.07-3.57-4.14 0-2.22 1.06-4.14 3.55-4.14 2.28 0 3.52 1.65 3.54 4.04.01 2.03-.87 4.24-3.52 4.24zM35.29 32.34v8.72h-1.33v-8.72H31v-1.16h7.24v1.16h-2.95zM43.86 30.95c-2.45 0-4.98 1.52-4.98 5.18 0 3.07 1.93 5.18 4.94 5.18 3.27 0 5-2.32 5-5.28 0-3.21-2.2-5.08-4.96-5.08zm.01 9.34c-2.54 0-3.56-2.07-3.56-4.14 0-2.22 1.06-4.14 3.55-4.14 2.28 0 3.52 1.65 3.53 4.04.02 2.03-.86 4.24-3.52 4.24zM60.38 35.85v5.21h-1.13v-1.39c-.83 1.2-2.26 1.63-3.61 1.63-3.05 0-4.92-2.14-4.92-5.06 0-2.52 1.51-5.31 5.1-5.31 1.26 0 2.5.4 3.44 1.26.66.63.96 1.27 1.12 1.59l-1.36.36c-.11-.29-.28-.74-.69-1.16-.39-.42-1.17-.96-2.48-.96-2.77 0-3.71 2.29-3.71 4.08 0 1.86.96 4.05 3.65 4.05 1.22 0 3.48-.6 3.44-3.22H55.8v-1.1l4.58.02zM68.18 36.79c.47-.09 2.33-.4 2.33-2.71 0-.91-.31-1.74-1.03-2.28-.77-.59-1.58-.59-2.95-.6h-3.66v9.87h1.29v-4.19h2.54l2.68 4.19h1.56l-2.76-4.28zm-1.41-1.01h-2.61v-3.5h2.55c.76 0 1.4-.01 1.92.42.56.46.59 1.13.59 1.39 0 .71-.32 1.37-1.23 1.59-.41.1-.8.1-1.22.1zM77.07 31.2H75.7l-3.76 9.87h1.4l1.1-3.02h3.76l1.07 3.02h1.39l-3.59-9.87zm-2.21 5.74 1.51-4.11 1.44 4.11h-2.95zM88.02 31.36c-.51-.17-1.07-.17-1.56-.17h-4.27v9.87h1.27v-4.18h2.85c.6 0 1.09 0 1.58-.16 1.32-.41 1.82-1.67 1.82-2.74 0-1.13-.53-2.21-1.69-2.62zm-.09 3.92c-.45.45-.96.45-1.72.45h-2.75v-3.4h3.05c.46 0 .95.01 1.38.38.46.39.52.92.52 1.26 0 .49-.14.98-.48 1.31zM98.15 36.55h-5.37v4.51h-1.32v-9.88h1.32v4.21h5.37v-4.21h1.33v9.88h-1.33v-4.51zM105.76 36.55v4.51h-1.33v-4.51l-3.48-5.35h1.56l2.59 4.18 2.64-4.18h1.56l-3.54 5.35zM2.34 51.82v4.64H1.02v-9.88h6.33v1.17H2.34v2.92h4.67v1.15H2.34zM10.38 51.96v3.35h5.7v1.15H9.1v-9.87h6.81v1.16h-5.53v3.05h4.81v1.16h-4.81zM21.48 51.9c-1.43-.29-3.52-.77-3.52-2.81 0-.98.53-1.59.91-1.92.88-.76 1.96-.84 2.64-.84.7 0 1.76.07 2.66.73.98.71 1.17 1.72 1.27 2.32l-1.33.09c-.01-.31-.06-1.09-.8-1.63-.5-.36-1.13-.47-1.76-.47-1.19 0-2.23.49-2.23 1.55 0 1.09 1.09 1.34 1.94 1.54l1.09.28c.76.18 1.16.27 1.55.43 1.48.62 1.7 1.8 1.7 2.46 0 .92-.38 1.79-1.26 2.39-.95.64-2.08.7-2.68.7-.89 0-3.95-.14-4.18-3.4l1.41-.18c.01.38.06 1.25.8 1.9.56.49 1.3.66 2.03.66 1.4 0 2.46-.69 2.46-1.97 0-1.15-.91-1.45-1.87-1.65l-.83-.18zM30.65 47.73v8.72h-1.33v-8.72h-2.96v-1.16h7.24v1.16h-2.95zM36.27 46.59v9.87h-1.33v-9.87h1.33zM44.5 46.59h1.4l-3.48 9.87H41.1l-3.33-9.87h1.4l2.61 8.25 2.72-8.25zM50.47 46.59H49.1l-3.76 9.87h1.4l1.1-3.02h3.76l1.07 3.02h1.39l-3.59-9.87zm-2.2 5.75 1.51-4.11 1.44 4.11h-2.95zM56.87 55.29h4.78v1.17h-6.1v-9.88h1.32v8.71z"
              /></svg
            ></a
          >
        </div>
      </section>


    </div>
  {/if}
</div>

<style>
  .top-bar {
    display: flex;
    justify-content: space-between;
  }

  .index-container {
    width: 100%;
    color: var(--fg);
    transition: color 450ms;
  }

  .index-trigger > span {
    display: inline-block;
    vertical-align: top;
  }

  .index-trigger svg {
    margin-top: 0.05em;
    height: 1.25em;
    width: 1.25em;
  }

  .index-trigger {
    padding-top: 0.85em;
    z-index: 10;
    font-size: 1em;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-decoration: underline;
    text-underline-offset: 0.2em;
    text-decoration-thickness: 3px;
  }

  .index-container.open {

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    background-color:var(--bg);
    backdrop-filter: blur(20px);

  }

  /* .index-list{
    display:flex;
    flex-wrap:wrap;
} */

  .index-card {
    width: 50%;
    padding: 1rem;
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  h1 span.title {
    text-decoration: underline;
    text-underline-offset: 0.2em;
    text-decoration-thickness: 3px;
  }



  img {
    max-width: 100%;
    height: auto;
  }

  /* .index-card:hover img{
    display:none;

} */

  .title-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .index-card h3 {
    display: inline;
    text-align: center;
    padding: 2rem;
  }

  .credits {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    min-height: 100vh;
  }

  @media screen and (min-width:769px){

  }

  h1 {
    margin-left: auto;
    margin-right: auto;
    margin-top: 0;
    text-align: left;
    max-width: 32em;
    padding-left: 0.25em;
    padding-right: 0.25em;
  }

  ol,
  ul {
    margin: 2em;
  }

  ol {

  }

  li {
    padding-top: 0.5em;
    margin-bottom: 1em;
  }

  p {
    max-width: 36em;
    margin-left: 0em;
    margin-right: 1em;
    text-align: left;
  }

  h2 {
    max-width: 80vh;
    font-size: 1em;
  }

  .explainer {

    font-size: 1em;
    position:relative;
    box-sizing: border-box;
    padding:1em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .explainer p {
    text-align: left;
    font-family: "Unica77";
    font-weight: normal;
  }

  .explainer,
  .map {
    flex:1 1 50%;
    min-height: 100vh;
    height:100vh;
    mix-blend-mode: normal;
    font-family: Helvetica;
    position:relative;
  }

  

  h1 {
    margin-left: 0;
    margin-bottom: 1.5em;
    padding-left: 0;
    font-size: 1.45rem;
    line-height: 1.4em;
    text-align: left;
    max-width: calc(100% - 1.5em);
    /* text-decoration: underline; */
  }

  .margo {
    padding-top: 1em;
    letter-spacing: 0.8px;
    display: block;
  }

  #c21_logo {
    height: 4rem;
    max-width: 18em;
  }

  .logobox {
    text-align: left;
    margin:4em 0 0 0;
  }

  .index-trigger.close {
    
    position: fixed;
    top: -.25em;
    right: calc( var(--scrollbar) + 0.25rem) ;
    width: 48px;
    height: 48px;
    border-radius:48px;
    /* background-color:var(--bg); */
    font-size: 1.5em;
    text-decoration: none;
    display:flex;
    justify-content: center;
    align-items: center;
    line-height:48px;
  }


  @media screen and (min-width: 1024px) {
    .index-card {
      /* width:25%; */
    }
        .credits{
      flex-direction: row;
    }

    .map{
      order:1;
    }

    .explainer{
      order:2;
    }

  }

</style>